import { Color } from '@alyle/ui/color';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PRIMARY_OUTLET } from '@angular/router';
import { da } from 'date-fns/locale';

@Component({
  selector: 'vex-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  $confirmTitle: string;
  positiveColor: string;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.$confirmTitle = this.data.positiveTitle ?? 'Delete';
    this.positiveColor = this.$confirmTitle === 'Delete' ? 'rgb(222, 53, 11)' : 'rgb(var(--color-primary))';
  }

}
